/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type DropDownAutoComplete_user$ref = any;
export type DropDownAutoCompleteRefetchQueryVariables = {
    readonly accountId?: string | null;
    readonly ceoId?: string | null;
    readonly inputValue?: string | null;
    readonly searchCEOS?: boolean | null;
    readonly searchEvents?: boolean | null;
    readonly searchProducts?: boolean | null;
};
export type DropDownAutoCompleteRefetchQueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly userInfo: ({
            readonly id: string;
            readonly " $fragmentRefs": DropDownAutoComplete_user$ref;
        }) | null;
    }) | null;
};
export type DropDownAutoCompleteRefetchQuery = {
    readonly response: DropDownAutoCompleteRefetchQueryResponse;
    readonly variables: DropDownAutoCompleteRefetchQueryVariables;
};



/*
query DropDownAutoCompleteRefetchQuery(
  $accountId: String
  $ceoId: String
  $inputValue: String
  $searchCEOS: Boolean
  $searchEvents: Boolean
  $searchProducts: Boolean
) {
  viewer {
    id
    userInfo(accountId: $accountId) {
      id
      ...DropDownAutoComplete_user_3iIZz3
    }
  }
}

fragment DropDownAutoComplete_user_3iIZz3 on User {
  ...AuthDialog_user
  id
  userId
  publicId
  permissions {
    id
    oneCommerce {
      id
      ceo {
        access
      }
    }
  }
  shoppingWithCeoUser {
    publicId
    id
  }
  DropDownAutoCompleteData: autoCompleteData(first: 25, ceoId: $ceoId, inputValue: $inputValue, searchCEOS: $searchCEOS, searchEvents: $searchEvents, searchProducts: $searchProducts) {
    edges {
      cursor
      node {
        id
        isCEO
        image
        ceoId
        isEvent
        isProduct
        routePath
        primaryLabel
        secondaryLabel
        productCategory
        __typename
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment AuthDialog_user on User {
  id
  role
  email
  lastName
  firstName
  hasSSOAccount
  shoppingWithCeoUser {
    userId
    id
  }
  cart {
    id
    eventId
    eventHostFirstName
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "accountId",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "ceoId",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "inputValue",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "searchCEOS",
            "type": "Boolean",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "searchEvents",
            "type": "Boolean",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "searchProducts",
            "type": "Boolean",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = [
        ({
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId",
            "type": "String"
        } as any)
    ], v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "userId",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "publicId",
        "args": null,
        "storageKey": null
    } as any), v5 = [
        ({
            "kind": "Variable",
            "name": "ceoId",
            "variableName": "ceoId",
            "type": "String"
        } as any),
        ({
            "kind": "Literal",
            "name": "first",
            "value": 25,
            "type": "Int"
        } as any),
        ({
            "kind": "Variable",
            "name": "inputValue",
            "variableName": "inputValue",
            "type": "String"
        } as any),
        ({
            "kind": "Variable",
            "name": "searchCEOS",
            "variableName": "searchCEOS",
            "type": "Boolean"
        } as any),
        ({
            "kind": "Variable",
            "name": "searchEvents",
            "variableName": "searchEvents",
            "type": "Boolean"
        } as any),
        ({
            "kind": "Variable",
            "name": "searchProducts",
            "variableName": "searchProducts",
            "type": "Boolean"
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "DropDownAutoCompleteRefetchQuery",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "userInfo",
                            "storageKey": null,
                            "args": (v2 /*: any*/),
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v1 /*: any*/),
                                {
                                    "kind": "FragmentSpread",
                                    "name": "DropDownAutoComplete_user",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "ceoId",
                                            "variableName": "ceoId",
                                            "type": null
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "inputValue",
                                            "variableName": "inputValue",
                                            "type": null
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "searchCEOS",
                                            "variableName": "searchCEOS",
                                            "type": null
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "searchEvents",
                                            "variableName": "searchEvents",
                                            "type": null
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "searchProducts",
                                            "variableName": "searchProducts",
                                            "type": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "DropDownAutoCompleteRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "userInfo",
                            "storageKey": null,
                            "args": (v2 /*: any*/),
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shoppingWithCeoUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        (v1 /*: any*/),
                                        (v4 /*: any*/)
                                    ]
                                },
                                (v1 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "lastName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "firstName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasSSOAccount",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "cart",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Cart",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "eventId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "eventHostFirstName",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "permissions",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PermissionsType",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "oneCommerce",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OneCommerceType",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "ceo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AccessType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "access",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "DropDownAutoCompleteData",
                                    "name": "autoCompleteData",
                                    "storageKey": null,
                                    "args": (v5 /*: any*/),
                                    "concreteType": "AutoCompleteEntryConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "AutoCompleteEntryEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "cursor",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AutoCompleteDataEntry",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isProduct",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v1 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "image",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "ceoId",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isEvent",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isCEO",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "routePath",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "primaryLabel",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "secondaryLabel",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "productCategory",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "__typename",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "pageInfo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "endCursor",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "hasNextPage",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedHandle",
                                    "alias": "DropDownAutoCompleteData",
                                    "name": "autoCompleteData",
                                    "args": (v5 /*: any*/),
                                    "handle": "connection",
                                    "key": "DropDownAutoComplete_DropDownAutoCompleteData",
                                    "filters": [
                                        "ceoId",
                                        "inputValue",
                                        "searchCEOS",
                                        "searchEvents",
                                        "searchProducts"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "DropDownAutoCompleteRefetchQuery",
            "id": null,
            "text": "query DropDownAutoCompleteRefetchQuery(\n  $accountId: String\n  $ceoId: String\n  $inputValue: String\n  $searchCEOS: Boolean\n  $searchEvents: Boolean\n  $searchProducts: Boolean\n) {\n  viewer {\n    id\n    userInfo(accountId: $accountId) {\n      id\n      ...DropDownAutoComplete_user_3iIZz3\n    }\n  }\n}\n\nfragment DropDownAutoComplete_user_3iIZz3 on User {\n  ...AuthDialog_user\n  id\n  userId\n  publicId\n  permissions {\n    id\n    oneCommerce {\n      id\n      ceo {\n        access\n      }\n    }\n  }\n  shoppingWithCeoUser {\n    publicId\n    id\n  }\n  DropDownAutoCompleteData: autoCompleteData(first: 25, ceoId: $ceoId, inputValue: $inputValue, searchCEOS: $searchCEOS, searchEvents: $searchEvents, searchProducts: $searchProducts) {\n    edges {\n      cursor\n      node {\n        id\n        isCEO\n        image\n        ceoId\n        isEvent\n        isProduct\n        routePath\n        primaryLabel\n        secondaryLabel\n        productCategory\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AuthDialog_user on User {\n  id\n  role\n  email\n  lastName\n  firstName\n  hasSSOAccount\n  shoppingWithCeoUser {\n    userId\n    id\n  }\n  cart {\n    id\n    eventId\n    eventHostFirstName\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '21fe935925df27dfac8f29b9fd32a209';
export default node;
